import React from "react";
import { Box, useDisclosure } from "@chakra-ui/react";
import Header from "../common/Header";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import PublicProductStrip from "../common/PublicProductStrip";
import PublicAmbient3D from "../common/PublicAmbient3D";

const Layout = ({ children }) => {
  const drawer = useDisclosure();

  return (
    <Box
      position="relative"
      minH="100vh"
      w="100%"
      maxW="100vw"
      overflowX="hidden"
      pb="env(safe-area-inset-bottom, 0px)"
    >
      <PublicAmbient3D />
      <Box
        position="relative"
        zIndex={1}
        display="flex"
        flexDirection="column"
        minH="100vh"
      >
        <Header onOpenMenu={drawer.onOpen} />
        <Navbar isOpen={drawer.isOpen} onClose={drawer.onClose} />
        <PublicProductStrip />
        <Box as="main" flex="1" maxW="100%" overflowX="hidden" position="relative">
          {children}
        </Box>
        <Footer />
      </Box>
    </Box>
  );
};

export default Layout;
